import React from "react";
import { CheckIcon, XIcon } from "lucide-react";
import { withGuide, withoutGuide } from "../data/content";
import { CtaButton } from "./CtaButton";
import { SectionHeading } from "./SectionHeading";
export function ClosingSection() {
  return <section className="bg-night py-16 text-white md:py-24" data-id="element-65" data-mp="12u515gc0tq06">
      <div className="wrap" data-id="element-66" data-mp="xspitw189xlh">
        <SectionHeading tone="dark" eyebrow="La decisión es tuya" title={<>
              Seguir probando o <span className="text-gold" data-id="element-68" data-mp="17s6km2dczrc6">saber qué hacer</span>
            </>} data-id="element-67" data-mp="xsfq40ostcc3" />

        <div className="mx-auto mt-12 grid max-w-[1000px] gap-5 md:grid-cols-2" data-id="element-69" data-mp="1lj3bnorn00h4">
          <div className="rounded-2xl border border-white/10 bg-night-card p-7" data-id="element-70" data-mp="1ll60i5h1znk9">
            <h3 className="display-title text-[30px] text-haze" data-id="element-71" data-mp="1hjuk8qk2keoq">Sin la guía</h3>
            <ul className="mt-5 list-none space-y-4 p-0" data-id="element-72" data-mp="1vi0xul1lbhwy">
              {withoutGuide.map(item => <li key={item} className="flex items-start gap-3 text-haze" data-id="element-73" data-mp="1qjzh46rmzuon">
                  <XIcon className="mt-1 h-4 w-4 shrink-0 text-[#F87171]" aria-hidden="true" data-id="element-74" data-mp="22ddvnvf5bk1q" />
                  {item}
                </li>)}
            </ul>
          </div>
          <div className="rounded-2xl border-2 border-gold bg-forest p-7" data-id="element-75" data-mp="2caa646olug8x">
            <h3 className="display-title text-[30px] text-gold" data-id="element-76" data-mp="2gbvg9k9r8gff">Con Tu iPhone, Tu Estudio</h3>
            <ul className="mt-5 list-none space-y-4 p-0" data-id="element-77" data-mp="2lb80ryd5lbeu">
              {withGuide.map(item => <li key={item} className="flex items-start gap-3" data-id="element-78" data-mp="2qab4nfhedbl8">
                  <CheckIcon className="mt-1 h-4 w-4 shrink-0 text-gold" strokeWidth={3} aria-hidden="true" data-id="element-79" data-mp="2q8gijxue3dfk" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mx-auto mt-12 max-w-[640px] text-center" data-id="element-80" data-mp="301xeb7e372lv">
          <p className="text-lg text-haze" data-id="element-81" data-mp="343am3n0qpfvf">
            Libro principal + 5 bonos para que tus fotos y videos muestren el valor de lo que vendés.
          </p>
          <div className="mt-7" data-id="element-82" data-mp="18y1jqeqayo5p">
            <CtaButton href="#offer-details" data-id="element-83" data-mp="18zciu18sz7qh">Quiero el pack completo</CtaButton>
          </div>
          <p className="mt-5 text-sm text-haze" data-id="element-84" data-mp="14y945i2hrhqu">
            Pago único de 27 USD en tu moneda local · Garantía de 10 días
          </p>
        </div>
      </div>
    </section>;
}